import styled from 'styled-components';

export const Container = styled.textarea`
  border: 1px solid ${({theme}) => theme.colors.gray[400]};
  border-radius: 8px;

  padding: 12px 16px;
  font-weight: 400;
  font-size: 12px;

  outline: none;

  width: 100%;
  height: 100%;

  resize: none;

  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    border-color: ${({ theme }) => theme.colors.orange.primary};
    box-shadow: 0 0 0 3px rgba(245, 128, 37, 0.15);
  }
`;
